/**
 * Back to Top.
 *
 * @package eBayAds
 */

import { debounce } from "./utils/functions";
import { InViewportAnimation } from './utils/in-viewport-animation';

( function ( $ ) {
	class BackToTop {

		/**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {

			this.backToTopEl = $( '#back-to-top' );
			this.siteFooter = $( 'footer#colophon.site-footer' );
			this.window = $( window );

			// The window scroll position after which we show the scroll to top button.
			this.scrollOffset = 200;

			if ( ! this.backToTopEl ) {
				return;
			}

			this.addEvents();

		}

		addEvents() {

			this.backToTopEl.on( 'click', this.scrollWindowToTop );
			this.window.on( 'scroll', () => debounce( this.toggleScrollToTopBtnVisibilty(), 1000 ) );

			$( document ).ready( () => {
				$( '.download-link-item' ).css( 'background', 'none' );
				$( '.search-icon' ).css( 'background', 'none' );
				$( '.slick-arrow .prev-nav-arrow' ).css( 'background', 'none' );
				$( '.nav-social-icons__link' ).css( 'background', 'none' );
				$( 'a.ebayads-arrow-link' ).css( 'background', 'none' );
				$( '.ebayads-social-share__link' ).css( 'background', 'none' );

				// Don't left align on single blog if it's inline with blog heading on left, so it wouldn't look overlapped.
				if ( $( 'body.single-post' ).length > 0 && $( '.ebayads-content-wrap-left' ).length > 0 ) {
					const articleHeading = $( '.ebayads-content-wrap-left' );
					const headingOffset = articleHeading.offset().top + articleHeading.height() + 20;
					$( 'article.type-post .entry-content h1' ).each( ( i, elem ) => {
						elem = $( elem );
						if ( elem.offset().top <= headingOffset ) {
							elem.css( 'left', '0' );
						}
					} );
				}

				const searchResultForm = $( '.search-result-form .search-form' );
				$( '.search-result-form .search-submit' ).hover( () => {
					searchResultForm.addClass( 'hover' );
				}, () => {
					searchResultForm.removeClass( 'hover' );
				} );
			} );

			new InViewportAnimation();
		}

		/**
		 * Toggle scroll button visibility.
		 *
		 * When the scroll position is large than scrollOffset
		 * we will show the scroll to top button,
		 * else hide it.
		 *
		 * @return {void}
		 */
		toggleScrollToTopBtnVisibilty() {

			// If the scroll position is larger than scrollOffset.
			if ( window.scrollY > this.scrollOffset ) {
				this.backToTopEl.addClass( 'is-visible' );

				const top_of_element = this.siteFooter.offset().top;
				const bottom_of_element = this.siteFooter.offset().top + this.siteFooter.outerHeight();
				const bottom_of_screen = $( window ).scrollTop() + $( window ).innerHeight();
				const top_of_screen = $( window ).scrollTop();

				if ( ( bottom_of_screen > top_of_element ) && ( top_of_screen < bottom_of_element ) ) {
					const diff = bottom_of_screen - top_of_element;
					this.backToTopEl.parent( '.back-to-top' ).css( 'bottom', ( 20 + diff ) + 'px' );
				} else {
					this.backToTopEl.parent( '.back-to-top' ).css( 'bottom', '20px' );
				}
			} else {
				this.backToTopEl.removeClass( 'is-visible' );
			}
		}

		/**
		 * Scroll window to top.
		 *
		 * When the back to top button is clicked scroll to top position.
		 * @return {void}
		 */
		scrollWindowToTop() {
			window.scrollTo( {
				top: 0,
				behavior: 'smooth'
			} );
		}

	}

	new BackToTop();

} )( jQuery );
